const BABY_SHOWER_IMAGES = [
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/o8yge99z_FOTO%2019.png",
    alt: "Chá do Heitor - tema aviador azul e dourado",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/96iy0sc0_FOTO%2020.png",
    alt: "Chá de bebê - tema rosa e lilás com nuvens",
  },
];

export default function BabyShower() {
  return (
    <section data-testid="baby-shower-section" className="py-24 bg-[#f9f9f9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-[#E4077B] text-xs tracking-[0.25em] uppercase font-medium">Sonhos Realizados</span>
          <h2
            className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mt-3"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Chá de Bebê
          </h2>
          <div className="w-12 h-0.5 bg-[#E4077B] mx-auto mt-4" />
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-[#555555] leading-relaxed text-base">
            A chegada de um bebê merece uma celebração cheia de carinho e significado. Criamos cenários especiais para celebrar essa doce espera, com decorações pensadas para meninos e meninas e preparadas para tornar esse encontro ainda mais bonito e inesquecível.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {BABY_SHOWER_IMAGES.map((img, i) => (
            <div
              key={i}
              className="overflow-hidden rounded-3xl hover-lift"
              data-testid={`baby-shower-image-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-72 md:h-96 object-cover transition-transform duration-500 hover:scale-105"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
